import React from 'react'
import { Link } from 'react-router-dom'
import { BsLinkedin, BsGithub, BsTwitter, BsInstagram, BsGooglePlay, BsApple } from "react-icons/bs";
import newsletter from '../images/newsletter.png';
import logo from '../images/profile-images/logo_transparent_1.png';

const Footer = () => {
  return (
    <>
      <footer className='py-4'>
        <div className='container-xxl'>
          <div className='row align-items-center'>
            <div className='col-5'>
              <div className='footer-top-data d-flex gap-30 align-items-center'>
                <img src={newsletter} alt='newsletter' />
                <h2 className='mb-0 text-white'>Sign Up for Neswletter</h2>
              </div>
            </div>
            <div className='col-7'>
              <div className="input-group">
                <input type="text" className="form-control py-1" placeholder="Your E-mail Address" aria-label="Your E-mail Address." aria-describedby="basic-addon2"/>
                <span className="input-group-text py-2" id="basic-addon2">
                  Subscribe
                </span>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <footer className='py-4'>
        <div className='container-xxl'>
          <div className='row'>
            <div className='col-md-3'>
              <h4 className='text-white mb-4'>Contact Us</h4>
              <div>
                <address className='text-white fs-6'>
                  Demo Store <br />
                  Old Mutual Building, Kimathi Street, <br />
                  Nairobi, Kenya <br />
                </address>
                <Link href='tel: +254712345678' className='mt-3 d-block mb-2 text-white'>
                  (+254) 712 345 678
                </Link>
                <Link href='mailto: moses.njehu.n@gmail.com' className='mt-2 d-block mb-1 text-white'>
                  moses.njehu.n@gmail.com
                </Link>
                <div className='social-icons d-flex align-items-center gap-30 mt-4'>
                  <Link className='text-white' href='#'>
                    <BsGithub  className='fs-4'/>
                  </Link>
                  <Link className='text-white' href='#'>
                    <BsLinkedin className='fs-4' />
                  </Link>
                  <Link className='text-white' href='#'>
                    <BsTwitter className='fs-4' />
                  </Link>
                  <Link className='text-white' href='#'>
                    <BsInstagram className='fs-4' />
                  </Link>
                </div>
              </div>
            </div>
            <div className='col-md-2'>
              <h4 className='text-white mb-4'>Information</h4>
              <div>
                <div className='footer-links d-flex flex-column'>
                  <Link to='/privacy-policy' className='text-white py-2 mb-1'>Privacy Policy</Link>
                  <Link to='/refund-policy' className='text-white py-2 mb-1'>Refund Policy</Link>
                  <Link to='/shipping-policy' className='text-white py-2 mb-1'>Shipping Policy</Link>
                  <Link to='/terms-and-conditions' className='text-white py-2 mb-1'>Terms of Service</Link>
                  <Link to='/blogs' className='text-white py-2 mb-1'>Blogs</Link>
                </div>
              </div>
            </div>
            <div className='col-md-2'>
              <h4 className='text-white mb-4'>Account</h4>
              <div>
                <div className='footer-links d-flex flex-column'>
                  <Link className='text-white py-2 mb-1'>About Us</Link>
                  <Link className='text-white py-2 mb-1'>FAQs</Link>
                  <Link className='text-white py-2 mb-1'>Contact</Link>
                  <Link className='text-white py-2 mb-1'>Search</Link>
                  <Link className='text-white py-2 mb-1'>Size Chart</Link>
                </div>
              </div>
            </div>
            <div className='col-md-2'>
              <h4 className='text-white mb-4'>Quick Links</h4>
              <div className='footer-links d-flex flex-column'>
                <Link className='text-white py-2 mb-1'>Accessories</Link>
                <Link className='text-white py-2 mb-1'>Laptops</Link>
                <Link className='text-white py-2 mb-1'>Headphones</Link>
                <Link className='text-white py-2 mb-1'>Tablets</Link>
                <Link className='text-white py-2 mb-1'>Watches</Link>
              </div>
            </div>
            <div className='col-md-3'>
              <h4 className='text-white mb-4'>Our App</h4>
              <div>
                <p className='text-white'>
                  Download our app and get extra 15% Discount on your first Order...
                </p>
              </div>
              <div className='d-flex'>
                <div className='col-md-6 px-1'>
                  <div className='google-play'>
                    <Link className='d-flex align-items-center gap-10 text-white justify-content-center'>
                    <div className='google-icon'>
                        <BsGooglePlay className='fs-5' />
                      </div>
                      <div className='d-flex flex-column gap-10'>
                        <p className='mb-0'>
                          Get it on <br />
                          <span>Google Play</span>
                        </p>
                      </div>
                    </Link>
                  </div>
                </div>
                <div className='col-md-6 px-1'>
                  <div className='app-store'>
                    <Link className='d-flex align-items-center gap-10 text-white justify-content-center'>
                      <div className='apple-icon'>
                        <BsApple className='fs-5' />
                      </div>
                      <div className='d-flex flex-column gap-10'>
                        <p className='mb-0'>
                          Get it on <br />
                          <span>App Store</span>
                        </p>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
              <div className='pt-4'>
                <img src={logo} className='img-fluid' alt='Monje Partners' />
              </div>
            </div>
          </div>
        </div>
      </footer>
      <footer className='py-4'>
        <div className='container-xxl'>
          <div className='row'>
            <div className='col-12'>
              <p className='text-center mb-0 text-white'>
                &copy; {new Date().getFullYear()}; Powered by Njehu Ngugi
              </p>
            </div>
          </div>
        </div>
      </footer>
    </>
  )
}

export default Footer